import { OrganizationBaseModel } from '@/features/tenant-manager/models';
import { DayjsSchema, jsonType } from '@/utils';
import { z } from 'zod';

/// ////////////////////////////////////////////
/// Enum
/// ////////////////////////////////////////////

const targetType = z.enum(['project', 'expenditure-cart']);

/// ////////////////////////////////////////////
/// Model
/// ////////////////////////////////////////////

const GroupBaseModel = z.object({
  id: z.string().uuid(),
  createdAt: z.string().datetime({ offset: true }),
  organizationId: z.string().uuid(),
  sharedOrganizationIds: z.string().uuid().array(),
  fiscalYear: z.number().int(),
  targetType,
  name: z.string().min(1),
  /** additionalContext only use for bns */
  additionalContext: jsonType.nullable(),
});

const GroupTargetBaseModel = z.object({
  groupId: z.string().uuid(),
  objectId: z.string().uuid(),
});
export const GroupTargetsModel = z.object({
  groupWiseDetails: GroupTargetBaseModel.extend({
    group: GroupBaseModel,
  }).array(),
});

export const GroupsModel = GroupBaseModel.extend({
  groupTargets: GroupTargetBaseModel.array(),
  organization: OrganizationBaseModel,
}).array();

export const GroupModel = GroupBaseModel.extend({
  groupTargets: GroupTargetBaseModel.extend({
    resourceObject: z.unknown(),
  }).array(),
});

/// ////////////////////////////////////////////
/// Schema
/// ////////////////////////////////////////////

const GroupFormBaseSchema = GroupBaseModel.pick({
  name: true,
}).extend({
  fiscalYear: DayjsSchema(),
  organizationIds: GroupBaseModel.shape.organizationId.array().min(1),
  sharedOrganizationIds: GroupBaseModel.shape.sharedOrganizationIds.optional(),
  category: z.string().nullish(),
});

export const GroupFormSchemaForRs = GroupFormBaseSchema.pick({
  name: true,
  fiscalYear: true,
  organizationIds: true,
});

export const GroupMutationParamsSchema = GroupFormBaseSchema.extend({
  additionalContext: z.any().optional(),
  targetType,
});

export const UpdateGroupMutationParamsSchema = GroupMutationParamsSchema.extend(
  {
    id: z.string().uuid(),
  },
).omit({
  targetType: true,
});

export const GroupTargetsMutationParamsSchema = z.string().uuid().array();

export const AddGroupTargetFormSchema = z.object({
  groupId: GroupBaseModel.shape.id,
});
